import PropTypes from 'prop-types'
import React from 'react'
import LazyWrapper from 'components/generic/LazyWrapper'
import FacebookLikeButton from 'components/generic/FacebookLikeButton'
import './styles.css'

function SocialNetworks(props) {
  if (!props.url) return null

  return (
    <LazyWrapper>
      <div className="networks">
        <FacebookLikeButton url={props.url} />
      </div>
    </LazyWrapper>
  )
}

SocialNetworks.propTypes = {
  url: PropTypes.string.isRequired
}

export default SocialNetworks
